import React, { useEffect, useState } from 'react';
import './EntryAnimation.css';
import Logo from '../../assets/LOGO.png';
import { getLenis } from '../../utils/lenis';

export default function EntryAnimation({ onFadeStart }) {
    const [show, setShow] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        const lenis = getLenis();
        if (lenis) lenis.stop();

        const fadeTimer = setTimeout(() => {
            setFadeOut(true);
            
            setTimeout(() => {
                if (onFadeStart) onFadeStart();
            }, 600);
            
        }, 3500);

        const removeTimer = setTimeout(() => {
            setShow(false);
            document.body.style.overflow = 'unset';
            const lenis = getLenis();
            if (lenis) lenis.start();
        }, 5000);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
            document.body.style.overflow = 'unset';
            const lenis = getLenis();
            if (lenis) lenis.start();
        };
    }, []);

    if (!show) return null;

    return (
        <div className={`entry-animation-container ${fadeOut ? 'fade-out' : ''}`}>
            <div className="entry-animation-content">
                <img src={Logo} alt="Jovexa Logo" className="entry-logo" />
                <h1 className="entry-text">JOVEXA</h1>
            </div>
        </div>
    );
}
